module.exports = __webpack_public_path__ + "img/VP-Standard-User.d1594bb4.jpg";